export const getCloudinaryUrl = (imageDomain, imagePath, height, width, format = 'jpg') => {
  const parameters = `c_fill,w_${width},h_${height},f_${format},q_auto:eco`;
  return `${imageDomain}/image/upload/${parameters}${imagePath}`;
};

export const getCloudinaryTemplateUrl = (image, height, width, format = 'jpg') => {
  if (!image?.cloudinaryUriTemplate) return '';
  const parameters = `c_fill,w_${width},h_${height},f_${format},q_auto:eco/`;
  return image.cloudinaryUriTemplate.replace('{+transform}', parameters);
};

export const getCloudinaryTemplateLogoUrl = (image, height, format = 'jpg') => {
  if (!image?.cloudinaryUriTemplate) return '';
  const parameters = `c_scale,h_${height},f_${format}/`;
  return image.cloudinaryUriTemplate.replace('{+transform}', parameters);
};
